
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createWarnContext } from "@/script/apps/recon/config/ReconConfig";
import { Warn } from "@/script/apps/recon/entity/ReconEntity";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";

@Options({})
export default class WarnDetail extends BaseDetail {
  private dataStates: Dict[] = [];
  private submitStates: Dict[] = [];

  public initData(): ServiceContext {
    return createWarnContext();
  }

  public newEntity() {
    const entity: Warn = {
      node: { name: "" },
      camera: { name: "" },
      cruise: { name: "" },
      nodeDetail: { name: "" },
    };
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const dictService = new DictService();
    dictService.loadChildItems("rec-warn-data-state", (data: any) => {
      this.dataStates = data;
    });
    dictService.loadChildItems("rec-warn-submit-state", (data: any) => {
      this.submitStates = data;
    });
  }
}
